import QRCode from 'react-qr-code'

import { cn } from '@/app/utils/cn'

const QR_SIZE = 132

interface StoreQrCodeProps {
  /** URL codificada no QR (link da loja ou da página /baixar). */
  value: string
  /** Texto exibido abaixo do QR. */
  caption: string
  className?: string
}

/**
 * QR Code em caixa verde para escanear com o celular. Usado na página /baixar
 * (um por loja) e no MobileAppModal (aponta para /baixar, que redireciona pela loja).
 */
export function StoreQrCode({ value, caption, className }: StoreQrCodeProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-3',
        className,
      )}
    >
      <div className="rounded-md bg-white p-2">
        <QRCode
          size={QR_SIZE}
          value={value}
          level="M"
          viewBox={`0 0 ${QR_SIZE} ${QR_SIZE}`}
          style={{ height: QR_SIZE, width: QR_SIZE }}
        />
      </div>
      <span className="text-center text-xs text-emerald-700">{caption}</span>
    </div>
  )
}
